/** Preset reasons shown when a selected invoice total differs from the bank
 *  movement. The backend requires a non-empty review_reason for any variance
 *  of two cents or more; "Other" reveals a free-text field. */
export const VARIANCE_REASONS = [
  'Bank charge / fee',
  'FX / exchange difference',
  'Rounding difference',
  'Early settlement discount',
  'Other',
] as const;

export function varianceReasonRequired(delta: number): boolean {
  return Math.abs(Number(delta) || 0) >= 0.02;
}

export function resolveVarianceReason(preset: string, custom: string): string {
  if (preset === 'Other') return (custom || '').trim();
  return (preset || '').trim();
}
